import { useMutation } from '@tanstack/react-query';
import { getThemeAxis } from '../queries/essays-queries/themes';
import { useEssayCoreStore } from '../stores/essayCoreStore';

export function useGetThemeAxis() {
  const { setThemeAxis } = useEssayCoreStore()

  const { mutate } = useMutation({
    mutationKey: ['getThemeAxis'], 
    mutationFn: () => getThemeAxis(),
    onSuccess: (response) => {
      setThemeAxis(response)
    },
    retry: false
  });

  return { mutate };
}
